export const DYNAMIC_CLIENT_EVOLUTION_CATMAN_KPIS = [
    //sales amount
    'cardholder_sales_amount_previous',
    'cardholder_sales_amount_with_promo_previous',
    'cardholder_sales_amount_without_promo_previous',
    'cardholder_sales_amount_lost_previous',
    'cardholder_sales_amount_lost_with_promo_previous',
    'cardholder_sales_amount_lost_without_promo_previous',
    'cardholder_sales_amount_regular',
    'cardholder_sales_amount_regular_delta',
    'cardholder_sales_amount_regular_evolution',
    'cardholder_sales_amount_regular_with_promo',
    'cardholder_sales_amount_regular_without_promo',
    'cardholder_sales_amount_regular_with_promo_evolution',
    'cardholder_sales_amount_regular_without_promo_evolution',
    'cardholder_sales_amount_regular_with_promo_delta',
    'cardholder_sales_amount_regular_without_promo_delta',
    'cardholder_sales_amount_new',
    'cardholder_sales_amount_new_without_promo',
    'cardholder_sales_amount_new_with_promo',
    'cardholder_sales_amount',
    'cardholder_sales_amount_evolution',
    'cardholder_sales_amount_delta',
    'cardholder_sales_amount_with_promo',
    'cardholder_sales_amount_with_promo_evolution',
    'cardholder_sales_amount_with_promo_delta',
    'cardholder_sales_amount_without_promo',
    'cardholder_sales_amount_without_promo_evolution',
    'cardholder_sales_amount_without_promo_delta',
    //sales quantity
    'cardholder_sales_quantity_previous',
    'cardholder_sales_quantity_with_promo_previous',
    'cardholder_sales_quantity_without_promo_previous',
    'cardholder_sales_quantity_lost_previous',
    'cardholder_sales_quantity_lost_without_promo_previous',
    'cardholder_sales_quantity_lost_with_promo_previous',
    'cardholder_sales_quantity_regular',
    'cardholder_sales_quantity_regular_delta',
    'cardholder_sales_quantity_regular_evolution',
    'cardholder_sales_quantity_regular_without_promo',
    'cardholder_sales_quantity_regular_with_promo',
    'cardholder_sales_quantity_regular_with_promo_evolution',
    'cardholder_sales_quantity_regular_without_promo_evolution',
    'cardholder_sales_quantity_regular_with_promo_delta',
    'cardholder_sales_quantity_regular_without_promo_delta',
    'cardholder_sales_quantity_new',
    'cardholder_sales_quantity_new_without_promo',
    'cardholder_sales_quantity_new_with_promo',
    'cardholder_sales_quantity',
    'cardholder_sales_quantity_evolution',
    'cardholder_sales_quantity_delta',
    'cardholder_sales_quantity_with_promo',
    'cardholder_sales_quantity_with_promo_evolution',
    'cardholder_sales_quantity_with_promo_delta',
    'cardholder_sales_quantity_without_promo',
    'cardholder_sales_quantity_without_promo_evolution',
    'cardholder_sales_quantity_without_promo_delta',
    //nb cardholders
    'nb_cardholders_previous',
    'nb_cardholders_lost_previous',
    'nb_cardholders_regular',
    'nb_cardholders_new',
    'nb_cardholders',
    'nb_cardholders_evolution',
    'nb_cardholders_delta'
];
export const DYNAMIC_CLIENT_EVOLUTION_KPI_DISPLAY_NAME = [
    //sales amount
    'dynamic_client_cardholder_sales_amount_previous',
    'dynamic_client_cardholder_sales_amount_with_promo_previous',
    'dynamic_client_cardholder_sales_amount_without_promo_previous',
    'dynamic_client_cardholder_sales_amount_lost_previous',
    'dynamic_client_cardholder_sales_amount_lost_with_promo_previous',
    'dynamic_client_cardholder_sales_amount_lost_without_promo_previous',
    'dynamic_client_cardholder_sales_amount_regular',
    'dynamic_client_cardholder_sales_amount_regular_delta',
    'dynamic_client_cardholder_sales_amount_regular_evolution',
    'dynamic_client_cardholder_sales_amount_regular_with_promo',
    'dynamic_client_cardholder_sales_amount_regular_without_promo',
    'dynamic_client_cardholder_sales_amount_regular_with_promo_evolution',
    'dynamic_client_cardholder_sales_amount_regular_without_promo_evolution',
    'dynamic_client_cardholder_sales_amount_regular_with_promo_delta',
    'dynamic_client_cardholder_sales_amount_regular_without_promo_delta',
    'dynamic_client_cardholder_sales_amount_new',
    'dynamic_client_cardholder_sales_amount_new_without_promo',
    'dynamic_client_cardholder_sales_amount_new_with_promo',
    'dynamic_client_cardholder_sales_amount',
    'dynamic_client_cardholder_sales_amount_evolution',
    'dynamic_client_cardholder_sales_amount_delta',
    'dynamic_client_cardholder_sales_amount_with_promo',
    'dynamic_client_cardholder_sales_amount_with_promo_evolution',
    'dynamic_client_cardholder_sales_amount_with_promo_delta',
    'dynamic_client_cardholder_sales_amount_without_promo',
    'dynamic_client_cardholder_sales_amount_without_promo_evolution',
    'dynamic_client_cardholder_sales_amount_without_promo_delta',
    //sales quantity
    'dynamic_client_cardholder_sales_quantity_previous',
    'dynamic_client_cardholder_sales_quantity_with_promo_previous',
    'dynamic_client_cardholder_sales_quantity_without_promo_previous',
    'dynamic_client_cardholder_sales_quantity_lost_previous',
    'dynamic_client_cardholder_sales_quantity_lost_without_promo_previous',
    'dynamic_client_cardholder_sales_quantity_lost_with_promo_previous',
    'dynamic_client_cardholder_sales_quantity_regular',
    'dynamic_client_cardholder_sales_quantity_regular_delta',
    'dynamic_client_cardholder_sales_quantity_regular_evolution',
    'dynamic_client_cardholder_sales_quantity_regular_without_promo',
    'dynamic_client_cardholder_sales_quantity_regular_with_promo',
    'dynamic_client_cardholder_sales_quantity_regular_with_promo_evolution',
    'dynamic_client_cardholder_sales_quantity_regular_without_promo_evolution',
    'dynamic_client_cardholder_sales_quantity_regular_with_promo_delta',
    'dynamic_client_cardholder_sales_quantity_regular_without_promo_delta',
    'dynamic_client_cardholder_sales_quantity_new',
    'dynamic_client_cardholder_sales_quantity_new_without_promo',
    'dynamic_client_cardholder_sales_quantity_new_with_promo',
    'dynamic_client_cardholder_sales_quantity',
    'dynamic_client_cardholder_sales_quantity_evolution',
    'dynamic_client_cardholder_sales_quantity_delta',
    'dynamic_client_cardholder_sales_quantity_with_promo',
    'dynamic_client_cardholder_sales_quantity_with_promo_evolution',
    'dynamic_client_cardholder_sales_quantity_with_promo_delta',
    'dynamic_client_cardholder_sales_quantity_without_promo',
    'dynamic_client_cardholder_sales_quantity_without_promo_evolution',
    'dynamic_client_cardholder_sales_quantity_without_promo_delta',
    //nb cardholders
    'dynamic_client_nb_cardholders_previous',
    'dynamic_client_nb_cardholders_lost_previous',
    'dynamic_client_nb_cardholders_regular',
    'dynamic_client_nb_cardholders_new',
    'dynamic_client_nb_cardholders',
    'dynamic_client_nb_cardholders_evolution',
    'dynamic_client_nb_cardholders_delta'
];
export const DYNAMIC_CLIENT_EVOLUTION_KPI_MAPPING = {
    //sales amount
    dynamic_client_cardholder_sales_amount_previous: 'cardholder_sales_amount_previous',
    dynamic_client_cardholder_sales_amount_with_promo_previous: 'cardholder_sales_amount_with_promo_previous',
    dynamic_client_cardholder_sales_amount_without_promo_previous: 'cardholder_sales_amount_without_promo_previous',
    dynamic_client_cardholder_sales_amount_lost_previous: 'cardholder_sales_amount_lost_previous',
    dynamic_client_cardholder_sales_amount_lost_with_promo_previous: 'cardholder_sales_amount_lost_with_promo_previous',
    dynamic_client_cardholder_sales_amount_lost_without_promo_previous: 'cardholder_sales_amount_lost_without_promo_previous',
    dynamic_client_cardholder_sales_amount_regular: 'cardholder_sales_amount_regular',
    dynamic_client_cardholder_sales_amount_regular_delta: 'cardholder_sales_amount_regular_delta',
    dynamic_client_cardholder_sales_amount_regular_evolution: 'cardholder_sales_amount_regular_evolution',
    dynamic_client_cardholder_sales_amount_regular_with_promo: 'cardholder_sales_amount_regular_with_promo',
    dynamic_client_cardholder_sales_amount_regular_without_promo: 'cardholder_sales_amount_regular_without_promo',
    dynamic_client_cardholder_sales_amount_regular_with_promo_evolution: 'cardholder_sales_amount_regular_with_promo_evolution',
    dynamic_client_cardholder_sales_amount_regular_without_promo_evolution: 'cardholder_sales_amount_regular_without_promo_evolution',
    dynamic_client_cardholder_sales_amount_regular_with_promo_delta: 'cardholder_sales_amount_regular_with_promo_delta',
    dynamic_client_cardholder_sales_amount_regular_without_promo_delta: 'cardholder_sales_amount_regular_without_promo_delta',
    dynamic_client_cardholder_sales_amount_new: 'cardholder_sales_amount_new',
    dynamic_client_cardholder_sales_amount_new_without_promo: 'cardholder_sales_amount_new_without_promo',
    dynamic_client_cardholder_sales_amount_new_with_promo: 'cardholder_sales_amount_new_with_promo',
    dynamic_client_cardholder_sales_amount: 'cardholder_sales_amount',
    dynamic_client_cardholder_sales_amount_evolution: 'cardholder_sales_amount_evolution',
    dynamic_client_cardholder_sales_amount_delta: 'cardholder_sales_amount_delta',
    dynamic_client_cardholder_sales_amount_with_promo: 'cardholder_sales_amount_with_promo',
    dynamic_client_cardholder_sales_amount_with_promo_evolution: 'cardholder_sales_amount_with_promo_evolution',
    dynamic_client_cardholder_sales_amount_with_promo_delta: 'cardholder_sales_amount_with_promo_delta',
    dynamic_client_cardholder_sales_amount_without_promo: 'cardholder_sales_amount_without_promo',
    dynamic_client_cardholder_sales_amount_without_promo_evolution: 'cardholder_sales_amount_without_promo_evolution',
    dynamic_client_cardholder_sales_amount_without_promo_delta: 'cardholder_sales_amount_without_promo_delta',
    //sales quantity
    dynamic_client_cardholder_sales_quantity_previous: 'cardholder_sales_quantity_previous',
    dynamic_client_cardholder_sales_quantity_with_promo_previous: 'cardholder_sales_quantity_with_promo_previous',
    dynamic_client_cardholder_sales_quantity_without_promo_previous: 'cardholder_sales_quantity_without_promo_previous',
    dynamic_client_cardholder_sales_quantity_lost_previous: 'cardholder_sales_quantity_lost_previous',
    dynamic_client_cardholder_sales_quantity_lost_without_promo_previous: 'cardholder_sales_quantity_lost_without_promo_previous',
    dynamic_client_cardholder_sales_quantity_lost_with_promo_previous: 'cardholder_sales_quantity_lost_with_promo_previous',
    dynamic_client_cardholder_sales_quantity_regular: 'cardholder_sales_quantity_regular',
    dynamic_client_cardholder_sales_quantity_regular_delta: 'cardholder_sales_quantity_regular_delta',
    dynamic_client_cardholder_sales_quantity_regular_evolution: 'cardholder_sales_quantity_regular_evolution',
    dynamic_client_cardholder_sales_quantity_regular_without_promo: 'cardholder_sales_quantity_regular_without_promo',
    dynamic_client_cardholder_sales_quantity_regular_with_promo: 'cardholder_sales_quantity_regular_with_promo',
    dynamic_client_cardholder_sales_quantity_regular_with_promo_evolution: 'cardholder_sales_quantity_regular_with_promo_evolution',
    dynamic_client_cardholder_sales_quantity_regular_without_promo_evolution: 'cardholder_sales_quantity_regular_without_promo_evolution',
    dynamic_client_cardholder_sales_quantity_regular_with_promo_delta: 'cardholder_sales_quantity_regular_with_promo_delta',
    dynamic_client_cardholder_sales_quantity_regular_without_promo_delta: 'cardholder_sales_quantity_regular_without_promo_delta',
    dynamic_client_cardholder_sales_quantity_new: 'cardholder_sales_quantity_new',
    dynamic_client_cardholder_sales_quantity_new_without_promo: 'cardholder_sales_quantity_new_without_promo',
    dynamic_client_cardholder_sales_quantity_new_with_promo: 'cardholder_sales_quantity_new_with_promo',
    dynamic_client_cardholder_sales_quantity: 'cardholder_sales_quantity',
    dynamic_client_cardholder_sales_quantity_evolution: 'cardholder_sales_quantity_evolution',
    dynamic_client_cardholder_sales_quantity_delta: 'cardholder_sales_quantity_delta',
    dynamic_client_cardholder_sales_quantity_with_promo: 'cardholder_sales_quantity_with_promo',
    dynamic_client_cardholder_sales_quantity_with_promo_evolution: 'cardholder_sales_quantity_with_promo_evolution',
    dynamic_client_cardholder_sales_quantity_with_promo_delta: 'cardholder_sales_quantity_with_promo_delta',
    dynamic_client_cardholder_sales_quantity_without_promo: 'cardholder_sales_quantity_without_promo',
    dynamic_client_cardholder_sales_quantity_without_promo_evolution: 'cardholder_sales_quantity_without_promo_evolution',
    dynamic_client_cardholder_sales_quantity_without_promo_delta: 'cardholder_sales_quantity_without_promo_delta',
    //nb cardholders
    dynamic_client_nb_cardholders_previous: 'nb_cardholders_previous',
    dynamic_client_nb_cardholders_lost_previous: 'nb_cardholders_lost_previous',
    dynamic_client_nb_cardholders_regular: 'nb_cardholders_regular',
    dynamic_client_nb_cardholders_new: 'nb_cardholders_new',
    dynamic_client_nb_cardholders: 'nb_cardholders',
    dynamic_client_nb_cardholders_evolution: 'nb_cardholders_evolution',
    dynamic_client_nb_cardholders_delta: 'nb_cardholders_delta'
};
//# sourceMappingURL=dynamicClientEvolution.kpis.js.map